import { useCallback, useEffect, useState } from 'react'

import { IConfigMarket } from '@Redux/interfaces'

import {useAppSelector} from "@App/hooks";
import { useMarkets } from '@App/hooks/useMarkets'

import { selectPriceAlertsList} from "@Redux/slices/trade/trades/selectors";
import {userState} from "@Redux/slices/user/UserSlice";

import { Alerts } from '@UI/crypto_exchange/desktop/pages/all_alerts/components/Alerts'
import { PriceAlert } from '@UI/crypto_exchange/desktop/pages/spot/components/PriceAlert'

import s from './styles.module.scss'

export const AlertsList = () => {
  const priceAlerts = useAppSelector(selectPriceAlertsList)

  const [isCollapsedPriseAlert, setIsCollapsedPriseAlert] = useState(true)
  const [selectedMarket, setSelectedMarket] = useState<IConfigMarket | null>(null)
  const { curr_wallet } = useAppSelector(userState)

  const markets = useMarkets()
  const priseAlertToggle = useCallback(() => setIsCollapsedPriseAlert((prevState) => !prevState), [])

  const openAlert = (market: IConfigMarket) => {
    setSelectedMarket(market)
    setIsCollapsedPriseAlert(false)
  }


  return (
    <div className={s.container}>
      <Alerts alerts={priceAlerts} markets={markets} openAlert={openAlert} />

      {curr_wallet && selectedMarket && (
        <PriceAlert
          isCollapsedPriseAlert={isCollapsedPriseAlert}
          priseAlertToggle={priseAlertToggle}
          targetCurrency={selectedMarket?.target_currency}
          sourceCurrency={selectedMarket?.source_currency}
          marketId={selectedMarket.id.toString()}
          marketSymbol={selectedMarket.symbol}
          wallet={curr_wallet}
        />
      )}
    </div>
  )
}
